export default [
	{
		type: "text",
		id: 1,
		items: [
			{
				id: 1,
				text: "Fachsemester:",
				type: "small",
			},
		],
	},
	{
		type: "special",
		id: 2,
		items: [
			{
				id: 2,
				text: "Studiengang:",
				label: [
					{
						id: 1,
						text: "B.Sc. Physik",
					},
					{
						id: 2,
						text: "B.Sc. Biophysik",
					},
					{
						id: 3,
						text: "Physik Lehramt",
					},
					{
						id: 4,
						text: "B.Sc. Quantum Engineering",
					},
					{
						id: 5,
						text: "M.Sc. Physik",
					},
					{
						id: 6,
						text: "SLLS Physik",
					},
					{
						id: 7,
						text: "M.Sc. Biophysik",
					},
					{
						id: 8,
						text: "M.Sc. Quantum Engineering",
					},
					{
						id: 9,
						text: "Sonstiges",
					},
				],
			},
		],
	},
	{
		type: "uni",
		id: 3,
		items: [
			{
				id: 3,
				text: "Der Dozent/Die Dozentin war engagiert und motiviert.",
			},
			{
				id: 4,
				text: "Ich konnte dem Tempo des Dozenten/der Dozentin gut folgen.",
			},
			{
				id: 5,
				text: "Der Dozent/Die Dozentin war stets gut vorbereitet.",
			},
			{
				id: 6,
				text: "Der Dozent/Die Dozentin war fachlich kompetent.",
			},
			{
				id: 7,
				text: "Dem Dozenten/Der Dozentin war es wichtig, dass die Teilnehmer/innen etwas lernen.",
			},
			{
				id: 8,
				text: "Der Dozent/Die Dozentin motivierte die Teilnehmer/innen.",
			},
			{
				id: 9,
				text: "Das Lernziel wurde mir deutlich.",
			},
			{
				id: 10,
				text: "Hinsichtlich des organisatorischen Ablaufs der Veranstaltung (z.B. Ort, Zeit, Leistungsanforderungen) bin ich gut informiert worden.",
			},
			{
				id: 11,
				text: "Die Veranstaltung war übersichtlich und verständlich.",
			},
			{
				id: 12,
				text: "Der inhaltliche Aufbau der Veranstaltung war logisch/nachvollziehbar.",
			},
			{
				id: 13,
				text: "Die Qualität der Unterrichtsmaterialien und -medien war gut.",
			},
			{
				id: 14,
				text: "Es wurden Anregungen zum vertiefenden Studium gegeben (z.B. Skripte, Weblinks).",
			},
			{
				id: 15,
				text: "Die Qualität des Unterrichtsraums war gut.",
			},
			{
				id: 16,
				text: "Die Qualität der technischen Ausstattung war gut.",
			},
			{
				id: 17,
				text: "Das behandelte Thema enthält Bezüge zu meiner späteren Berufstätigkeit.",
			},
			{
				id: 18,
				text: "Die Inhalte sind anschaulich (Beispiele).",
			},
			{
				id: 19,
				text: "Das Thema wurde gut durch Anwendungsbeispiele abgebildet.",
			},
		],
	},
	{
		type: "bi",
		id: 4,
		items: [
			{
				id: 20,
				text: "Die Schwierigkeit des Stoffes war...",
			},
			{
				id: 21,
				text: "Der Umfang des Stoffes war...",
			},
			{
				id: 22,
				text: "Das Tempo der Stoffvermittlung war...",
			},
			{
				id: 23,
				text: "Die Anforderungen der Veranstaltung waren...",
			},
			{
				id: 24,
				text: "Der Zeitaufwand für die Veranstaltung insgesamt (inkl. Vor- und Nachbereitung) war...",
			},
			{
				id: 25,
				text: "Insgesamt empfand ich die Veranstaltung als...",
			},
		],
	},
	{
		type: "uni",
		id: 5,
		items: [
			{
				id: 26,
				text: "Insgesamt fand ich die Veranstaltung gut.",
			},
			{
				id: 27,
				text: "In der Veranstaltung habe ich viel gelernt.",
			},
			{
				id: 28,
				text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
			},
			{
				id: 29,
				text: "Ich würde die Veranstaltung weiterempfehlen.",
			},
		],
	},
	{
		type: "text",
		id: 6,
		items: [
			{
				id: 30,
				text: "Durchschnittlicher Aufwand für die Veranstaltung in Stunden pro Woche:",
				type: "small",
			},
			{
				id: 31,
				text: "Besonders gut fand ich:",
			},
			{
				id: 32,
				text: "Störend fand ich:",
			},
			{
				id: 33,
				text: "Verbesserungsvorschläge:",
			},
			{
				id: 34,
				text: "Wurden Vorkenntnisse vorausgesetzt, die Ihnen gefehlt haben? Wenn ja, welche?",
			},
		],
	},
];
